var _rect, _path, _path2, _path3, _path4, _rect2, _g, _path5, _path6, _ellipse, _path7, _rect3, _path8, _path9, _path0, _path1, _rect4, _g2, _path10, _path11, _path12, _ellipse2, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgFlatSurface({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 120,
    viewBox: "0 0 184 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 72.265,
    y: 8.74477,
    width: 108.348,
    height: 71.5288,
    rx: 7.265,
    transform: "rotate(90 72.265 8.74477)",
    fill: "white",
    stroke: "#0F574E",
    strokeWidth: 1.47
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 92.6147V97.8771C7 100.712 9.29795 103.01 12.1326 103.01H17.534",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67 92.6147V97.8771C67 100.712 64.702 103.01 61.8674 103.01H56.466",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 33.4048V28.1424C7 25.3077 9.29795 23.0098 12.1326 23.0098H17.534",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67 33.4048V28.1424C67 25.3077 64.702 23.0098 61.8674 23.0098H56.466",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6970_149870",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 26,
    width: 52,
    height: 73
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.8081,
    y: 27.4624,
    width: 50.561,
    height: 70.7776,
    rx: 4.39875,
    fill: "white",
    stroke: "#0F574E",
    strokeWidth: 1.1025
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6970_149870)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.1953,
    y: 28.0137,
    width: 53.7906,
    height: 69.6751,
    rx: 3.8475,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.6528,
    y: 67.1958,
    width: 22.0022,
    height: 8.28378,
    rx: 3.29625,
    fill: "#7CE9DA",
    stroke: "#0F574E",
    strokeWidth: 1.1025
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.52,
    y: 88.854,
    width: 13.3379,
    height: 2.50761,
    rx: 1.2538,
    fill: "#A8F0E7",
    stroke: "#0F574E",
    strokeWidth: 1.1025
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7456 84.7262H28.9347C29.9147 84.7262 30.7119 83.898 30.7119 82.8807V73.1834C30.7119 72.166 29.9146 71.3379 28.9347 71.3379H17.7456C16.7661 71.3379 15.9688 72.166 15.9688 73.1834V82.8807C15.9688 83.898 16.7661 84.7262 17.7456 84.7262ZM26.5615 83.762H20.1193V83.1043C20.1193 81.9192 20.72 80.8831 21.6171 80.2888C22.1241 80.6138 22.7127 80.8036 23.3424 80.8036C23.9707 80.8036 24.558 80.6142 25.0641 80.2898C25.9609 80.8842 26.5615 81.9197 26.5615 83.1044V83.762ZM20.8563 77.0868C20.8563 75.5661 21.9717 74.3294 23.3424 74.3294C24.7108 74.3294 25.8244 75.5661 25.8244 77.0868C25.8244 78.6046 24.7108 79.8394 23.3424 79.8394C21.9718 79.8394 20.8563 78.6045 20.8563 77.0868ZM16.897 73.1834C16.897 72.6975 17.2778 72.3021 17.7456 72.3021H28.9347C29.4029 72.3021 29.7837 72.6975 29.7837 73.1834V82.8807C29.7837 83.3665 29.403 83.762 28.9347 83.762H27.4897V83.1043C27.4897 81.6883 26.8233 80.437 25.8049 79.651C26.3905 78.9833 26.7527 78.081 26.7527 77.0867C26.7527 75.0346 25.2229 73.3651 23.3424 73.3651C21.4595 73.3651 19.928 75.0345 19.928 77.0867C19.928 78.0797 20.2897 78.9809 20.8746 79.6483C19.8556 80.4339 19.191 81.6878 19.191 83.1043V83.762H17.7456C17.2778 83.762 16.897 83.3665 16.897 82.8807V73.1834Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7458 77.9551H37.566C37.2358 77.9551 36.9688 78.2108 36.9688 78.5266C36.9688 78.8426 37.236 79.0981 37.566 79.0981H53.7458C54.076 79.0981 54.3431 78.8424 54.3431 78.5266C54.3431 78.2108 54.076 77.9551 53.7458 77.9551Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7458 80.6992H37.566C37.2358 80.6992 36.9688 80.9549 36.9688 81.2707C36.9688 81.5867 37.236 81.8423 37.566 81.8423H53.7458C54.076 81.8423 54.3431 81.5866 54.3431 81.2707C54.3431 80.9549 54.076 80.6992 53.7458 80.6992Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2279 85.2715H37.4232C37.172 85.2715 36.9688 85.5272 36.9688 85.843C36.9688 86.159 37.1721 86.4145 37.4232 86.4145H58.2279C58.4791 86.4145 58.6823 86.1588 58.6823 85.843C58.6823 85.5271 58.4791 85.2715 58.2279 85.2715Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2279 89.8438H37.4232C37.172 89.8438 36.9688 90.0994 36.9688 90.4153C36.9688 90.7312 37.1721 90.9868 37.4232 90.9868H58.2279C58.4791 90.9868 58.6823 90.7311 58.6823 90.4153C58.6823 90.0993 58.4791 89.8438 58.2279 89.8438Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3319 93.3991C49.5516 93.0439 49.7712 92.6887 49.8844 92.7067C49.9975 92.7247 49.9975 93.1266 50.0611 93.1561C50.1247 93.1855 50.2518 92.8304 50.3174 92.7923C50.3829 92.7542 50.3829 93.0439 50.3829 93.1745C50.3829 93.2677 50.5909 92.8927 50.9351 92.5137C51.0215 92.4186 51.129 92.7329 51.1704 92.8537C51.2117 92.9745 51.2348 92.9465 51.4606 92.5535C51.6864 92.1605 52.1141 91.4035 52.3807 90.9013C52.6473 90.3992 52.7398 90.1749 52.8048 90.0359C52.8697 89.897 52.9044 89.8503 52.7373 90.6347C52.5702 91.4191 52.2003 93.036 51.8999 94.0605C51.5995 95.0851 51.3799 95.4683 51.2262 95.6984C51.0726 95.9285 50.9917 95.994 50.8807 95.9342C50.5524 95.7575 50.4302 95.336 50.3195 94.9738C50.2578 94.772 50.2203 94.5274 50.1965 94.2527C50.1727 93.978 50.1727 93.6789 50.2594 93.3706C50.4381 92.7352 50.8022 92.3987 50.9887 92.3468C51.0686 92.3245 51.129 92.3415 51.1761 92.4164C51.4322 92.8235 51.0495 93.0872 51.0595 93.1531C51.0745 93.252 51.5088 93.2376 51.115 93.2664C50.7213 93.2951 49.5883 93.3045 48.5481 93.2766C47.5078 93.2487 46.5946 93.1833 46.1819 93.1355C45.7692 93.0878 45.8848 93.0598 47.164 93.022C48.4432 92.9841 50.8824 92.9374 52.7228 92.8292C54.5631 92.721 55.7307 92.5528 56.9688 92.3795",
    stroke: "#0F574E",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.8081,
    y: 27.4624,
    width: 50.561,
    height: 70.7776,
    rx: 4.39875,
    stroke: "#0F574E",
    strokeWidth: 1.1025
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.3594,
    y: 28.0137,
    width: 49.4585,
    height: 33.935,
    rx: 3.8475,
    fill: "#E9FBF9"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 61.9473H62",
    stroke: "#0F574E",
    strokeWidth: 1.1025
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8909 51.1132C36.8987 51.1132 36.9062 51.1148 36.9139 51.1148C36.9217 51.1148 36.9277 51.1134 36.9347 51.1134C38.4623 51.1063 39.9249 50.4948 41.0025 49.4126C42.0802 48.3304 42.6852 46.8656 42.6852 45.3387C42.6852 43.8118 42.0802 42.347 41.0025 41.2648C39.9249 40.1826 38.4623 39.5711 36.9347 39.564C36.9277 39.564 36.9209 39.5625 36.9139 39.5625C36.907 39.5625 36.8987 39.564 36.8909 39.5641C35.362 39.5691 33.8975 40.1797 32.8182 41.2621C31.7389 42.3445 31.1328 43.8104 31.1328 45.3386C31.1328 46.8669 31.7389 48.3328 32.8182 49.4152C33.8975 50.4976 35.362 51.1082 36.8909 51.1132ZM32.425 47.0688C32.9622 47.3722 33.65 47.6189 34.4645 47.7869C34.6325 48.6005 34.8789 49.2876 35.1822 49.8245C34.5564 49.5817 33.988 49.2112 33.5133 48.7368C33.0386 48.2624 32.668 47.6943 32.425 47.0688ZM34.3032 46.7633C32.8531 46.4025 32.0985 45.8025 32.0985 45.3388C32.0985 44.8751 32.8531 44.2753 34.3032 43.914C34.1994 44.8609 34.1994 45.8164 34.3032 46.7633ZM36.9144 40.5257H36.917C37.3807 40.5289 37.9789 41.2826 38.3391 42.729C37.3917 42.6251 36.4358 42.6251 35.4885 42.729C35.8488 41.2827 36.4468 40.5293 36.9105 40.5257C36.9118 40.5259 36.9131 40.5257 36.9144 40.5257ZM35.2978 43.7231C36.3702 43.5774 37.4574 43.5774 38.5298 43.7231C38.6759 44.795 38.6759 45.8818 38.5298 46.9537C37.4574 47.0994 36.3702 47.0994 35.2978 46.9537C35.1521 45.8818 35.1521 44.7951 35.2978 43.7231ZM35.4885 47.9479C36.4358 48.0518 37.3917 48.0518 38.3391 47.9479C37.9791 49.3946 37.3807 50.1481 36.917 50.1513H36.9144C36.9131 50.1513 36.9118 50.1513 36.9105 50.1513C36.4468 50.1478 35.8486 49.3944 35.4885 47.9483V47.9479ZM38.6454 49.8245C38.9487 49.2875 39.1951 48.6003 39.3631 47.7867C40.1775 47.6187 40.8652 47.3721 41.4024 47.0687C41.1595 47.6943 40.7889 48.2624 40.3143 48.7369C39.8396 49.2114 39.2713 49.5819 38.6455 49.8247L38.6454 49.8245ZM39.5244 43.9137C40.9748 44.2747 41.7293 44.8746 41.7293 45.3385C41.7293 45.8025 40.9748 46.4023 39.5244 46.7631C39.6285 45.8161 39.6285 44.8606 39.5244 43.9137ZM41.4024 43.6081C40.8652 43.3047 40.1775 43.0582 39.3631 42.8902C39.1951 42.0765 38.9487 41.3893 38.6454 40.8524C39.2712 41.0952 39.8396 41.4656 40.3143 41.9401C40.789 42.4146 41.1596 42.9828 41.4024 43.6083V43.6081ZM35.1819 40.8529C34.8787 41.3898 34.6323 42.0768 34.4643 42.8904C33.6498 43.0585 32.9622 43.3051 32.4247 43.6086C32.6677 42.9831 33.0384 42.4151 33.5131 41.9406C33.9878 41.4661 34.5561 41.0957 35.1819 40.8529Z",
    fill: "#168374"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.0784,
    cy: 11.0003,
    rx: 7.52371,
    ry: 7.52371,
    fill: "#ECFDF5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9141 3.29883C69.3009 3.29883 67.724 3.76069 66.3827 4.626C65.0414 5.49132 63.996 6.72123 63.3787 8.1602C62.7613 9.59916 62.5998 11.1826 62.9145 12.7102C63.2292 14.2378 64.0061 15.641 65.1467 16.7423C66.2874 17.8436 67.7407 18.5937 69.3229 18.8975C70.905 19.2014 72.545 19.0454 74.0353 18.4494C75.5257 17.8533 76.7995 16.844 77.6957 15.5489C78.592 14.2539 79.0703 12.7314 79.0703 11.1738C79.0703 9.08525 78.211 7.08221 76.6814 5.60536C75.1518 4.12851 73.0772 3.29883 70.9141 3.29883ZM69.7489 14.3187L66.8359 11.5062L67.7626 10.6113L69.7489 12.529L74.0659 8.36133L74.9955 9.2534L69.7489 14.3187Z",
    fill: "#00D492"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 175.999,
    y: 8.51039,
    width: 108.348,
    height: 71.5288,
    rx: 7.265,
    transform: "rotate(90 175.999 8.51039)",
    fill: "white",
    stroke: "#0F574E",
    strokeWidth: 1.47
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M110.734 91.3804V96.6428C110.734 99.4774 113.032 101.775 115.867 101.775H121.268",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M170.734 91.3804V96.6428C170.734 99.4774 168.436 101.775 165.602 101.775H160.2",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M110.734 32.1704V26.908C110.734 24.0733 113.032 21.7754 115.867 21.7754H121.268",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M170.734 32.1704V26.908C170.734 24.0733 168.436 21.7754 165.602 21.7754H160.2",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6970_149870",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 26,
    width: 53,
    height: 73
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 115.542,
    y: 27.228,
    width: 50.561,
    height: 70.7776,
    rx: 4.39875,
    fill: "white",
    stroke: "#0F574E",
    strokeWidth: 1.1025
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6970_149870)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 113.93,
    y: 27.7793,
    width: 53.7906,
    height: 69.6751,
    rx: 3.8475,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.387,
    y: 66.9614,
    width: 22.0022,
    height: 8.28378,
    rx: 3.29625,
    fill: "#7CE9DA",
    stroke: "#0F574E",
    strokeWidth: 1.1025
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.254,
    y: 88.6196,
    width: 13.3379,
    height: 2.50761,
    rx: 1.2538,
    fill: "#A8F0E7",
    stroke: "#0F574E",
    strokeWidth: 1.1025
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.48 84.4918H132.669C133.649 84.4918 134.446 83.6637 134.446 82.6463V72.949C134.446 71.9317 133.649 71.1035 132.669 71.1035H121.48C120.5 71.1035 119.703 71.9317 119.703 72.949V82.6463C119.703 83.6637 120.5 84.4918 121.48 84.4918ZM130.296 83.5276H123.854V82.8699C123.854 81.6848 124.454 80.6487 125.352 80.0544C125.858 80.3794 126.447 80.5692 127.077 80.5692C127.705 80.5692 128.292 80.3798 128.798 80.0554C129.695 80.6498 130.296 81.6853 130.296 82.87V83.5276ZM124.591 76.8524C124.591 75.3318 125.706 74.095 127.077 74.095C128.445 74.095 129.559 75.3318 129.559 76.8524C129.559 78.3702 128.445 79.6051 127.077 79.6051C125.706 79.6051 124.591 78.3701 124.591 76.8524ZM120.631 72.949C120.631 72.4632 121.012 72.0677 121.48 72.0677H132.669C133.137 72.0677 133.518 72.4632 133.518 72.949V82.6463C133.518 83.1322 133.137 83.5276 132.669 83.5276H131.224V82.8699C131.224 81.4539 130.558 80.2027 129.539 79.4166C130.125 78.7489 130.487 77.8466 130.487 76.8523C130.487 74.8002 128.957 73.1307 127.077 73.1307C125.194 73.1307 123.662 74.8001 123.662 76.8523C123.662 77.8453 124.024 78.7465 124.609 79.4139C123.59 80.1995 122.925 81.4534 122.925 82.8699V83.5276H121.48C121.012 83.5276 120.631 83.1322 120.631 82.6463V72.949Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.48 77.7207H141.3C140.97 77.7207 140.703 77.9764 140.703 78.2922C140.703 78.6082 140.97 78.8638 141.3 78.8638H157.48C157.81 78.8638 158.077 78.6081 158.077 78.2922C158.077 77.9764 157.81 77.7207 157.48 77.7207Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.48 80.4648H141.3C140.97 80.4648 140.703 80.7205 140.703 81.0364C140.703 81.3523 140.97 81.6079 141.3 81.6079H157.48C157.81 81.6079 158.077 81.3522 158.077 81.0364C158.077 80.7205 157.81 80.4648 157.48 80.4648Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.962 85.0371H141.158C140.906 85.0371 140.703 85.2928 140.703 85.6086C140.703 85.9246 140.906 86.1802 141.158 86.1802H161.962C162.213 86.1802 162.417 85.9245 162.417 85.6086C162.417 85.2927 162.213 85.0371 161.962 85.0371Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.962 89.6094H141.158C140.906 89.6094 140.703 89.8651 140.703 90.1809C140.703 90.4969 140.906 90.7524 141.158 90.7524H161.962C162.213 90.7524 162.417 90.4967 162.417 90.1809C162.417 89.8649 162.213 89.6094 161.962 89.6094Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.066 93.1647C153.286 92.8095 153.506 92.4544 153.619 92.4724C153.732 92.4903 153.732 92.8922 153.795 92.9217C153.859 92.9511 153.986 92.596 154.052 92.5579C154.117 92.5198 154.117 92.8095 154.117 92.9401C154.117 93.0333 154.325 92.6583 154.67 92.2793C154.756 92.1843 154.863 92.4986 154.905 92.6194C154.946 92.7401 154.969 92.7121 155.195 92.3191C155.421 91.9262 155.848 91.1691 156.115 90.667C156.382 90.1648 156.474 89.9405 156.539 89.8016C156.604 89.6627 156.639 89.6159 156.472 90.4003C156.305 91.1847 155.935 92.8016 155.634 93.8262C155.334 94.8507 155.114 95.2339 154.961 95.464C154.807 95.6942 154.726 95.7596 154.615 95.6998C154.287 95.5232 154.165 95.1017 154.054 94.7394C153.992 94.5377 153.955 94.2931 153.931 94.0183C153.907 93.7436 153.907 93.4445 153.994 93.1362C154.172 92.5009 154.537 92.1644 154.723 92.1124C154.803 92.0901 154.863 92.1071 154.911 92.1821C155.167 92.5891 154.784 92.8529 154.794 92.9187C154.809 93.0176 155.243 93.0033 154.849 93.032C154.456 93.0608 153.323 93.0701 152.282 93.0422C151.242 93.0143 150.329 92.9489 149.916 92.9012C149.504 92.8534 149.619 92.8254 150.898 92.7876C152.178 92.7498 154.617 92.703 156.457 92.5949C158.298 92.4867 159.465 92.3184 160.703 92.1451",
    stroke: "#0F574E",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.542,
    y: 27.228,
    width: 50.561,
    height: 70.7776,
    rx: 4.39875,
    stroke: "#0F574E",
    strokeWidth: 1.1025
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.094,
    y: 27.7793,
    width: 49.4585,
    height: 33.935,
    rx: 3.8475,
    fill: "#E9FBF9"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M115.734 61.7129H165.734",
    stroke: "#0F574E",
    strokeWidth: 1.1025
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M140.625 50.8788C140.633 50.8788 140.641 50.8805 140.648 50.8805C140.656 50.8805 140.662 50.879 140.669 50.879C142.197 50.8719 143.659 50.2604 144.737 49.1782C145.815 48.096 146.42 46.6312 146.42 45.1043C146.42 43.5774 145.815 42.1126 144.737 41.0304C143.659 39.9482 142.197 39.3367 140.669 39.3296C140.662 39.3296 140.655 39.3281 140.648 39.3281C140.641 39.3281 140.633 39.3296 140.625 39.3297C139.096 39.3347 137.632 39.9453 136.553 41.0277C135.473 42.1101 134.867 43.576 134.867 45.1043C134.867 46.6325 135.473 48.0984 136.553 49.1808C137.632 50.2632 139.096 50.8738 140.625 50.8788ZM136.159 46.8344C136.697 47.1379 137.384 47.3845 138.199 47.5526C138.367 48.3661 138.613 49.0532 138.917 49.5901C138.291 49.3473 137.722 48.9769 137.248 48.5024C136.773 48.028 136.402 47.4599 136.159 46.8344ZM138.038 46.529C136.587 46.1682 135.833 45.5681 135.833 45.1044C135.833 44.6407 136.587 44.0409 138.038 43.6796C137.934 44.6265 137.934 45.582 138.038 46.529ZM140.649 40.2913H140.651C141.115 40.2945 141.713 41.0482 142.073 42.4947C141.126 42.3907 140.17 42.3907 139.223 42.4947C139.583 41.0484 140.181 40.295 140.645 40.2914C140.646 40.2915 140.647 40.2913 140.649 40.2913ZM139.032 43.4887C140.105 43.343 141.192 43.343 142.264 43.4887C142.41 44.5607 142.41 45.6474 142.264 46.7194C141.192 46.865 140.105 46.865 139.032 46.7194C138.886 45.6474 138.886 44.5607 139.032 43.4887ZM139.223 47.7136C140.17 47.8174 141.126 47.8174 142.073 47.7136C141.713 49.1602 141.115 49.9137 140.651 49.9169H140.649C140.647 49.9169 140.646 49.9169 140.645 49.9169C140.181 49.9135 139.583 49.1601 139.223 47.7139V47.7136ZM142.38 49.5901C142.683 49.0532 142.93 48.366 143.097 47.5523C143.912 47.3843 144.6 47.1377 145.137 46.8343C144.894 47.4599 144.523 48.028 144.049 48.5025C143.574 48.977 143.006 49.3475 142.38 49.5903L142.38 49.5901ZM143.259 43.6793C144.709 44.0404 145.464 44.6402 145.464 45.1042C145.464 45.5681 144.709 46.1679 143.259 46.5287C143.363 45.5818 143.363 44.6263 143.259 43.6793ZM145.137 43.3737C144.6 43.0704 143.912 42.8238 143.097 42.6558C142.93 41.8421 142.683 41.1549 142.38 40.618C143.006 40.8608 143.574 41.2313 144.049 41.7058C144.523 42.1803 144.894 42.7484 145.137 43.374V43.3737ZM138.916 40.6185C138.613 41.1554 138.367 41.8425 138.199 42.656C137.384 42.8241 136.697 43.0707 136.159 43.3743C136.402 42.7487 136.773 42.1807 137.247 41.7062C137.722 41.2318 138.29 40.8613 138.916 40.6185Z",
    fill: "#168374"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M144.302 7.66992H168.359C172.778 7.66992 176.359 11.2516 176.359 15.6699V108.67C176.359 113.088 172.778 116.67 168.359 116.67H125.359L144.302 7.66992Z",
    fill: "#263238",
    fillOpacity: 0.2
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.844,
    cy: 11.2386,
    rx: 7.52371,
    ry: 7.52371,
    fill: "#ECFDF5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M174.68 3.5332C170.135 3.5332 166.523 7.0207 166.523 11.4082C166.523 15.7957 170.135 19.2832 174.68 19.2832C179.224 19.2832 182.836 15.7957 182.836 11.4082C182.836 7.0207 179.224 3.5332 174.68 3.5332ZM177.826 15.3457L174.68 12.3082L171.534 15.3457L170.602 14.4457L173.748 11.4082L170.602 8.3707L171.534 7.4707L174.68 10.5082L177.826 7.4707L178.758 8.3707L175.612 11.4082L178.758 14.4457L177.826 15.3457Z",
    fill: "#FF6467"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgFlatSurface);
export default __webpack_public_path__ + "static/media/img-flat-surface.ded12e1a1bb96a9e775d605dfb37b271.svg";
export { ForwardRef as ReactComponent };